export default "__VITE_ASSET__DABXk0FX__"